import React, { useState } from "react";
import { Box, Chip } from "@mui/material";
import CustomTabPanel from "../components/TabPanel";
import ClientPulse from "../components/ClientPulse";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Tooltip } from "@mui/material";
import { useClientContext } from "../context/ClientContext";
import Grid from "@mui/material/Grid2";
import CustomChatbot from "../components/CustomChatbot";
import ClientMeetingPrep from "../components/ClientMeetingPrep";
import ClientMetric from "../components/ClientMetric";
import IndustryInsights from "../components/IndustryInsights";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { v4 as uuidv4 } from "uuid";
import { useChatbotContext } from "../context/ChatbotContext";
import { useRef, useEffect } from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useAuth } from "../context/AuthContextProvider";

function ClientInsights() {
  const [outerTabValue, setOuterTabValue] = React.useState(0);
  const [innerTabValue, setInnerTabValue] = React.useState(0);
  const { clientName, setClientName } = useClientContext();
  const [selectedTabName, setSelectedTabName] = React.useState("clientMetric");
  const { sessionId, setSessionId } = useChatbotContext();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return; // Prevent second call
    hasRun.current = true;

    const randomString = uuidv4();
    //console.log("randomString", randomString);
    setSessionId(randomString);
  }, []);

  //console.log("selectedTabName", selectedTabName);
  const handleClientChange = (event) => {
    //console.log('client name', event.target.value);
    setClientName(event.target.value);
  };

  const handleOuterTabChange = (event, newValue) => {
    setOuterTabValue(newValue);
    if (newValue === 0) {
      setInnerTabValue(0); // Reset inner tab to first tab
      setSelectedTabName("clientMetric");
    } else if (newValue === 1) {
      setSelectedTabName("industryInsights");
    } else if (newValue === 2) {
      setSelectedTabName("clientMeetingPrep");
    } else {
      setSelectedTabName("default");
    }
  };

  const handleInnerTabChange = (newValue) => {
    setInnerTabValue(newValue);
    newValue === 1
      ? setSelectedTabName("clientPulse")
      : setSelectedTabName("clientMetric");
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <Grid container>
      <Grid item size={8} px={3}>
        <Box>
          {/* Outer Tabs */}
          <div
            className="flex justify-between"
            style={{ borderBottom: "1px solid #A6A6A6" }}
          >
            <Tabs
              value={outerTabValue}
              onChange={handleOuterTabChange}
              aria-label="outer tabs"
              variant="fullWidth"
              sx={{ width: "100%" }}
            >
              <Tooltip title="360-degree client view incorporating financials, key metrics, and intelligence insights derived from the bank's internal data, investor presentations, annual reports, equity research reports, and news publications​​">
                <Tab
                  label="Client Insights"
                  //title="360-degree view of the client, including financials, key metrics, and intelligence insights​​"
                  {...a11yProps(0)}
                  sx={{
                    fontWeight: "600",
                    fontSize: "12px",
                    alignItems: "flex-start",
                    paddingLeft: "0px",
                  }}
                />
              </Tooltip>
              <Tooltip title="Industry trends, regulatory changes, and market benchmarks gathered from industry reports, news, and government regulations to evaluate client performance">
                <Tab
                  label="Industry Insights"
                  //title="Industry trends, regulatory updates, and market benchmarks to compare client performance​"
                  {...a11yProps(1)}
                  sx={{ fontWeight: "600", fontSize: "12px" }}
                />
              </Tooltip>
              <Tooltip title="Notes from past and upcoming meetings, key discussion topics, and personalized client offers​​">
                <Tab
                  label="Client Meeting Prep"
                  //title="Notes from past and upcoming meetings, key discussion topics, and personalized client offers​​"
                  {...a11yProps(2)}
                  sx={{ fontWeight: "600", fontSize: "12px" }}
                />
              </Tooltip>
            </Tabs>
          </div>
          {/* Outer Tab Panels */}
          <CustomTabPanel value={outerTabValue} index={0}>
            {/* Inner Tabs for Client Insights */}
            <div className="flex justify-between items-center">
              <div className="flex flex-start mx-0 my-2 gap-4">
                <Tooltip title="Tracking client relationships, product holdings, financial trends, and key performance metrics using the bank's internal data, including account details, product portfolios, risk and compliance information​​​">
                  <Chip
                    label="Customer 360°"
                    clickable
                    onClick={() => handleInnerTabChange(0)}
                    sx={{
                      fontWeight: "600",
                      fontSize: "10px",
                      height: "24px",
                      minWidth: "150px",
                      backgroundColor:
                        innerTabValue === 0 ? "#00555C" : "#f0f0f0",
                      color: innerTabValue === 0 ? "#fff" : "#000",
                      "&:hover": {
                        backgroundColor:
                          innerTabValue === 0 ? "#00555C" : "#f0f0f0",
                        color: innerTabValue === 0 ? "#fff" : "#000",
                      },
                    }}
                  />
                </Tooltip>
                <Tooltip title="Updates on client news, analyst insights, early warning signals, and key business priorities sourced from investor presentations, annual reports, equity research reports, and news publications​​">
                  <Chip
                    label="Market Scan"
                    //title="Updates on client news, analyst insights, early warning signals, and key business focus areas​​"
                    clickable
                    onClick={() => handleInnerTabChange(1)}
                    sx={{
                      fontWeight: "600",
                      fontSize: "10px",
                      height: "24px",
                      minWidth: "150px",
                      backgroundColor:
                        innerTabValue === 1 ? "#00555C" : "#f0f0f0",
                      color: innerTabValue === 1 ? "#fff" : "#000",
                      "&:hover": {
                        backgroundColor:
                          innerTabValue === 1 ? "#00555C" : "#f0f0f0",
                        color: innerTabValue === 1 ? "#fff" : "#000",
                      },
                    }}
                  />
                </Tooltip>
              </div>
              <div>
                <Tooltip title={<div>Please click on Help button <HelpOutlineIcon fontSize="16px"/> to get description of all the Key metrics </div>}>
                  <InfoOutlinedIcon className="text-main" fontSize="12px"/>
                </Tooltip>
              </div>
            </div>
            <CustomTabPanel value={innerTabValue} index={0}>
              <ClientMetric />
            </CustomTabPanel>
            <CustomTabPanel value={innerTabValue} index={1}>
              <ClientPulse />
            </CustomTabPanel>
          </CustomTabPanel>
          <CustomTabPanel value={outerTabValue} index={1}>
            <IndustryInsights />
          </CustomTabPanel>
          <CustomTabPanel value={outerTabValue} index={2}>
            <ClientMeetingPrep />
          </CustomTabPanel>
        </Box>
      </Grid>
      <Grid size={4} pt={1}>
        <CustomChatbot height={"83vh"} selectedTab={selectedTabName} />
      </Grid>
    </Grid>
  );
}

export default ClientInsights;
